import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore, YA_CAPTCHA_ENABLED } from 'vpl.tas';
import { ItemEditBtns, NewsletterCheckbox } from 'vpl.tas';
import { number_format, ymLead } from 'vpl.tas';


export const Calc = {
    components: {
        ItemEditBtns,
        NewsletterCheckbox
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        number_format: number_format,
        changeType(event){
            let select = $(event.target);
            this.choosenType = select.val();
            this.calcResult();
        },
        getSquares(){
            let square = 0;
            if($(this.$el) && $(this.$el).find('#calcRangePl').length){
                square = +$(this.$el).find('#calcRangePl').val().replace(/\s+/g, '');
            }
            return square;
        },
        calcResult(){

            let total = 0,
                square = this.getSquares(),
                textResult = '';

            textResult += 'Тип объекта: ' + this.choosenCalcData.NAME + `
Площадь: ` + square + `
`;

            if(this.choosenCalcData.PRICE){
                total += this.choosenCalcData.PRICE * (+square);
            }

            for(let i in this.choosenCalcData.ITEMS){
                if($(this.$el).find('#additional-' + i).length && $(this.$el).find('#additional-' + i).prop('checked')){
                    total += this.choosenCalcData.ITEMS[i].PRICE * (+square);
                    //this.choosenCalcData.ITEMS[i].NAME
                    textResult += 'дополнительно - ' + this.choosenCalcData.ITEMS[i].NAME + `
`;
                }
            }

            if(total){
                total = number_format(total, 0, '.', ' ') + ' ₽';
                textResult += 'Итого: ' + total;
            }else{
                 textResult += 'Итого: Договорная';
            }

            this.total = total;
            this.calcTextResult = textResult;

        },
        execCaptcha(){
            vplSiteStore.capresolved = true;
            this.sendForm();
        },
        sendForm(){
            let form = $(this.$el).find('form'),
                data = {};

            $.each($("input,textarea,button,select", form), function () {
                if ($(this).attr("type") == "checkbox") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = true;
                    }
                } else if ($(this).attr("type") == "radio") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = $(this).val();
                    }
                } else if (
                    $(this).attr("name") !== undefined &&
                    $(this).attr("name").length
                ) {
                    data[$(this).attr("name")] = $(this).val();
                }
            });

            data['WEB_FORM_ID'] = 4;
            data['web_form_submit'] = 'y';
            data['sessid'] = BX.bitrix_sessid();
            data['url'] = window.location.href;

            data['smart-token'] = this.yatoken;

            if(vplSiteStore.capresolved){
                data['skip-captcha'] = 'Y';
            }

            $.ajax({
                url: '/ajax/form.php',
                method: 'POST',
                data: data,
                success: (response) => {
                    form.find(".is-error").removeClass("is-error");
                    response = JSON.parse(response);

                    if (!response.ERRORS || !Object.keys(response.ERRORS).includes("CAPTCHA")) {
                        vplSiteStore.capresolved = true;
                    }

                    if (response.STATUS == "OK") {
                        ymLead('calculator', response);
                        form.find("input[type=text],input[type=email],textarea").val("");

                        $('#success').modal();

                    } else {
                        for (var i in response.ERRORS) {
                            if (i == "CAPTCHA") {
                                form.find(".captcha").addClass("is-error");
                            } else {
                                form
                                    .find("[name=" + i + "]")
                                    .parent()
                                    .addClass("is-error");
                            }
                        }
                    }
                }
            });
        }
    },
    data(){
        return {
            choosenType: 0,
            total: 0,
            calcTextResult: '',
            captcha: false,
            yatoken: ''
        }
    },
    updated(){

    },
    mounted(){

        let self = this,
            sliderDl = document.getElementById('calcRange'),
            calcRangePl = $("#calcRangePl");

        if (sliderDl !== null && sliderDl !== undefined) {
            noUiSlider.create(sliderDl, {
                start: [100],
                connect: true,
                behaviour: "tap",
                range: {
                    'min': 1,
                    'max': 10000
                },
                step: 1,
                format: {
                    prefix: '',
                    mark: ',',
                    decimals: 2,
                    thousand: ',',
                    to: function to(value) {
                    return +value.toFixed(0);
                    },
                    from: function from(value) {
                    return value;
                    }
                }
            });
            sliderDl.noUiSlider.on("update", function (values, handle) {
                var valuePrice = String(+values[handle].toFixed(3)).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ");
                calcRangePl.val(valuePrice);
                self.calcResult(event);
            });
            calcRangePl.keyup(function () {
                sliderDl.noUiSlider.set([Number($(this).val().replace(" ", "")), null]);
                sliderDl.noUiSlider.set([null, Number($(this).val().replace(" ", ""))]);
                self.calcResult(event);
            });
        }

        $(this.$el).find('.js-select').niceSelect();
        $(this.$el).find('select.js-select').change((event) => this.changeType(event));


        let interval = setInterval(()=>{
            if(this.captcha === false &&  (!YA_CAPTCHA_ENABLED || typeof window.smartCaptcha !== "undefined")){

              let self = this;
              this.captcha = YA_CAPTCHA_ENABLED && window.smartCaptcha.render($(this.$el).find('.js-captcha')[0], {
                  sitekey: self.YA_CLIENT_KEY,
                  invisible: true,
                  callback: function(token) {
                      window.yaToken = token;
                      self.yatoken = token;
                      self.sendForm();
                  },
                  hideShield: true,
              });

              new Cleave($(this.$el).find('.js-phone')[0], {
                numericOnly: true,
                delimiters: [" (", ") ", "-", "-"],
                blocks: [1, 3, 3, 2, 2]
              });

              clearInterval(interval);
            }
        }, 500);
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'YA_CLIENT_KEY']),
        calcData(){
            return this.struct[this.structKey].componentData.DATA
        },
        choosenCalcData(){
            return this.calcData[this.choosenType];
        },
        choosenCalcDops(){
            return this.choosenCalcData.ITEMS;
        },
        totalSum(){
            return this.calcRsult();
        },
        url(){
            return window.location.href;
        }
    },
    template: `
<section v-if="this.calcData && this.YA_CLIENT_KEY" class="section calc lazy-bg">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Калькулятор стоимости
                </h2>
            </div>
        </div>
        <form @submit.prevent="execCaptcha()">
            <div class="calc__leftside">
                <div class="calc__type">
                    <div class="calc__type-item">
                        <div class="calc__type-item-title">Тип объекта</div>
                        <div class="form-select">
                            <select @change="changeType($event)" class="sort__select js-select">
                                <option v-for="item, key in this.calcData" :value="key">{{item.NAME}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="calc__type-item">
                        <div class="calc__type-item-title">Площадь объекта, м<sup>2</sup></div>
                        <div class="field js-material-input is-required">
                            <input class="field__input" name="calcRangePl" id="calcRangePl" autocomplete="off" type="text" value="100">
                            <div class="catalog__filter-item-range-dragger-wp">
                                <div class="catalog__filter-item-range-dragger js-filter-dragger" id="calcRange"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calc__checkboxes">
                   <div class="calc__checkboxes-wp">
                        <label v-for="item, key in this.choosenCalcData.ITEMS" :for="'additional-' + key" class="filter__item-checkbox">
                            <div class="filter__item-checkbox-top">
                                <input @change="this.calcResult()" type="checkbox" :id="'additional-' + key">
                                <div class="filter__item-checkbox-value-name">{{item.NAME}}</div>
                            </div>
                            <div v-if="item.PRICE" class="filter__item-checkbox-value">
                                <div class="filter__item-checkbox-value-sum">
                                    <span>от</span>
                                    {{item.PRICE}} ₽
                                </div>
                            </div>
                        </label>
                   </div>
                   <div class="calc__sum">
                        <div class="calc__sum-title">Итоговая стоимость:</div>
                        <div v-if="this.total" class="calc__sum-amount">
                            <span>от </span>
                            {{this.total}}
                        </div>
                        <div v-else class="calc__sum-amount">
                            Договорная
                        </div>
                   </div>
                </div>
            </div>
            <div class="calc__rightside">
                <div class="field js-material-input is-required">
                    <input class="field__input" name="form_text_23" id="order-name" autocomplete="off" type="text">
                    <label class="field__label" for="order-name">Представьтесь</label>
                    <span class="field__error-text">Заполнено некорректно.</span>
                </div>
                <div class="field js-material-input is-required">
                    <input class="field__input js-phone" name="form_text_24" id="order-tel" autocomplete="off" type="text">
                    <label class="field__label" for="order-tel">Телефон</label>
                    <span class="field__error-text">Заполнено некорректно.</span>
                </div>
                <div class="field js-material-input is-required">
                    <input class="field__input" name="form_email_25" id="order-mail" autocomplete="off" type="text">
                    <label class="field__label" for="order-mail">Электронная почта</label>
                    <span class="field__error-text">Заполнено некорректно.</span>
                </div>
                <div class="field js-material-input is-required">
                    <textarea class="field__input field__input--textarea" rows="3" name="form_textarea_26" id="modal-text" placeholder="Ваше сообщения" autocomplete="off"></textarea>
                    <span class="field__error-text">Заполнено некорректно.</span>
                </div>
                <div class="form__submit">
                    <div class="form__submit-container">
                        <div class="captcha">
                            <div class="captcha">
                                <div class="captcha js-captcha"></div>
                            </div>
                        </div>
                        <button type="submit" name="web_form_submit" value="Y" class="btn btn--green">
                            Отправить
                        </button>
                    </div>
                    <div class="checkbox">
                        <input type="checkbox" name="politic" class="checkbox__input js-politic js-politic-auto" id="politic-order">
                        <label for="politic-order" class="checkbox__label">
                            При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                        </label>
                    </div>
                    <NewsletterCheckbox />
                </div>
                <input type="hidden" name="form_text_27" :value="this.url">
                <div style="display: none;">
                    <textarea name="form_textarea_28" :value="this.calcTextResult"></textarea>
                </div>
            </div>
        </form>
    </div>
</section>
    `
}